/** @format */
import styled, { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';

import { StyledModelSearchResultsProps } from '.';

export const GridWrapper = styled.div`
    display: grid;
    grid-template-areas: 'filters filters' 'pagination-controls sort' 'results results';

    ${smallTablet(css`
        grid-template-areas: 'filters sort' 'results results';
        grid-template-columns: 1fr 1fr;
    `)}
`;

const baseStyles = () => css`
    .control-group {
        display: none;
    }

    .small-tablet-filters {
        display: none;
    }

    .desktop-filters {
        display: grid;
    }

    ${smallTablet(css`
        .control-group {
            display: block;
        }

        .divider {
            display: none;
        }

        .small-tablet-filters {
            display: flex;
            flex-grow: 1;
        }

        .desktop-filters {
            display: none;
        }
    `)}

    .spelling-suggestion-notice {
        display: block;
        width: 100%;
        margin-bottom: var(--layout-spacing-24);
    }

    .link-wrapper {
        position: relative;
    }

    .card-link {
        width: 100%;
        height: 100%;
        padding: 0.4rem;
        border-radius: 1.2rem;

        > span {
            height: 100%;
        }
    }

    .control-group {
        position: relative;
    }

    .control-group-skeleton {
        height: 100%;
        width: 100%;
        position: absolute;
        gap: 0.4rem;
        display: none;
    }
`;

const loadingStyles = () => css`
    .control-group-skeleton {
        display: flex;
    }

    .control-group-content {
        visibility: hidden;
    }
`;

export const styles = ({ isLoading }: StyledModelSearchResultsProps) => {
    return css`
        ${baseStyles()}
        ${isLoading && loadingStyles()}
    `;
};
